import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import {z} from 'zod';
import {
  betterAuthErrorSchema,
  betterAuthSessionResponseSchema,
} from './better-auth-response.schemas';

const getSessionResponseSchema = z.object({
  data: betterAuthSessionResponseSchema.nullish(),
  error: betterAuthErrorSchema.nullish(),
});

export type BetterAuthGetSessionResponse = z.output<typeof getSessionResponseSchema>;

export class BetterAuthGetSessionResponseValidator implements Validator<BetterAuthGetSessionResponse> {
  readonly standardSchema = getSessionResponseSchema;

  validate(value: unknown): Result<BetterAuthGetSessionResponse, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);

    if (!parsed.success) {
      return err(
        new ValidationError(
          parsed.error.issues[0]?.message ?? 'Unexpected session response shape.',
        ),
      );
    }

    return ok(parsed.data);
  }
}
